module.exports = __webpack_public_path__ + "img/744.e58a7377.jpg";